'use client';

import React, { createContext } from 'react';
import useDynamicHeightChange from '@/hooks/useDynamicHeightChange';
interface IDynamicHeightContext {
  height: number;
  isHeightChanged: boolean;
}
const DynamicHeightContext = createContext<IDynamicHeightContext | null>(null);
const DynamicHeightContextProvider: React.FC<React.PropsWithChildren> = ({
  children
}) => {
  const {
    height,
    isHeightChanged
  } = useDynamicHeightChange();
  return <DynamicHeightContext.Provider value={{
    height,
    isHeightChanged
  }} data-sentry-element="unknown" data-sentry-component="DynamicHeightContextProvider" data-sentry-source-file="DynamicHeightContext.tsx">
      {children}
    </DynamicHeightContext.Provider>;
};
const useDynamicHeightContext = () => {
  const context = React.useContext(DynamicHeightContext);
  if (!context) {
    throw new Error('useDynamicHeightContext must be used within a DynamicHeightContextProvider');
  }
  return context;
};
export { DynamicHeightContextProvider, useDynamicHeightContext };